<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Detalle de Cita</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="Cita!=null">
            <div class="row">
              <div class="col-4 border-right">
                <div class="row"><h4>Datos del Solicitante</h4></div>
                <div class="row"><b>Nombre: </b><span>{{Cita.InformacionDeSolicitante.NombreCompleto}}</span></div>
                <div class="row"><b>Teléfono: </b><span>{{Cita.InformacionDeSolicitante.Telefono}}</span></div>
                <div class="row"><b>Correo electrónico: </b><span>{{Cita.InformacionDeSolicitante.CorreoElectronico}}</span></div>
                <div class="row"><b>Fecha y hora solicitada: </b><span>{{Cita.AgendaBloque.FechaHoraString}}</span></div>
              </div>
              <div class="col-8" v-if="!estatusGuardados">
                <table class="table table-striped table-light table-hover" id="tablaExpedientes">
                  <thead class="thead-dark">
                    <tr class="visible-element">
                      <th>No. de expediente</th>
                      <th>Trámite</th>
                      <th>Disponibilidad</th>
                      <th>Motivo</th>
                      <th>Reagendamiento</th>
                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <template v-for="Tramite in Cita.TramitesCita">
                      <tr v-for="Expediente in Tramite.Expedientes">
                        <td>
                          {{Expediente.NumeroDeExpediente}}<br /> {{Expediente.TipoDocumento_DBPJ.Nombre}}<br />{{Expediente.Materia_DBPJ.Nombre}}</td>
                        <td>{{Tramite.TipoTramite.Nombre
                          }}
                        </td>
                        <td><input type="checkbox" checked @change="validarCheckBox(listaCheckBox[Expediente.Indice],Expediente.Indice)" v-model="listaCheckBox[Expediente.Indice]" /></td>
                        <td>
                          <C015TiposEstatusDeExpedientes v-if="!listaCheckBox[Expediente.Indice]"
                                                         v-on:valorParaElPadre="cambioTipoEstatusDeExpediente"
                                                         :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                                         :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                                         :idDelInput="''+Expediente.Indice"
                                                         :parametros="parametros_TiposEstatusDeExpedientes[0]"
                                                         :valorDefinido="parametros_TiposEstatusDeExpedientes.ValorDefinido">
                          </C015TiposEstatusDeExpedientes>
                        </td>
                        <td>
                          <i v-if="listaBotonAgendamiento[Expediente.Indice]" class="fas fa-calendar-day fa-2x" @click="modalReagendamiento(Expediente.Indice)" />
                          <span v-if="listaFechaReagendamiento[Expediente.Indice] != null">{{listaFechaReagendamiento[Expediente.Indice]}}</span>
                          <i v-if="listaFechaReagendamiento[Expediente.Indice] != null" class="fas fa-times fa-2x" @click="cancelarReagendamiento(Expediente.Indice)"/>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="Cita.TramitesCita.length == 0"><td colspan="5">La cita no cuenta con trámites.</td></tr>
                  </tbody>
                </table>
                <div class="row">
                  <div class="col-4"></div>
                  <div class="col-4">
                    <input type="button" class="form-control" value="Regresar" @click="confirmacionCancelar" />
                  </div>
                  <div class="col-4">
                    <input type="button" class="form-control" value="Confirmar" v-bind:disabled="deshabilitarBotonConfirmar" @click="reagendarExpedientes" />
                  </div>
                </div>
              </div>
              <div class="col-8" v-else>
                <p>
                  <b>
                    Escriba el contenido del texto que será enviado al solicitante via correo electrónico a su dirección {{Cita.InformacionDeSolicitante.CorreoElectronico
                            }}. Puede agregar información adicional al mensaje si es necesario.
                            </b>
                            </p>
                            <p v-html="textoGenerado"> </p>
                            <textarea rows="5" class="form-control" v-model="textoEditable"></textarea>
                            <div class="row">
                              <div class="col-4"></div>
                              <div class="col-4" style="margin-top:10px;">
                                <input type="button" class="form-control" value="Volver" @click="VolverExpedientes" />
                              </div>
                              <div class="col-4" style="margin-top:10px;">
                                <input type="button" class="form-control" value="Enviar" @click="EnviarCorreoSolicitante" />
                              </div>
                            </div>
</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="modal fade"
         id="modalConfirmacion"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="tituloModalConfirmacion">Reagendar Expediente</h5>
            <button type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <span>Día:</span>
              </div>
              <div class="col-3">
                <C004AgendaBloqueFechas v-on:valorParaElPadre="cambioAgendaBloqueFecha"
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                        :idDelInput="'CatalogoAgendaBloqueFechas'"
                                        :parametros="parametros_AgendaBloqueFechas"
                                        :valorDefinido="parametros_AgendaBloqueFechas.ValorDefinido"
                                        :key="parametros_AgendaBloqueFechas.FechaOriginal">
                </C004AgendaBloqueFechas>
              </div>
              <div class="col-3">
                <span>Hora:</span>
              </div>
              <div class="col-3">
                <C004AgendaBloqueHoras v-on:valorParaElPadre="cambioAgendaBloqueHora"
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                        :idDelInput="'CatalogoAgendaBloqueHoras'"
                                        :parametros="parametros_AgendaBloqueHoras"
                                        :valorDefinido="parametros_AgendaBloqueHoras.ValorDefinido"
                                       :key="parametros_AgendaBloqueHoras.Fecha">
                </C004AgendaBloqueHoras>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal"> Cancelar </button>
            <button type="button" class="btn btn-primary" id="botonModalConfirmacion" @click="guardarFechaReagendamiento" data-dismiss="modal"> Reagendar </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    props: ['citaId'],
    data() {
      return {
        enumeraciones,
        catalogos,
        parametros_AgendaBloqueFechas: {
          ValorDefinido: 0,
          AreaId: 1,
          AgendaBloqueFecha: null,
          FechaOriginal: null,
          FechaSeleccionada: null
        },
        parametros_AgendaBloqueHoras: {
          ValorDefinido: 0,
          AreaId: 1,
          Fecha: null,
          BloqueId: -1,
          Hora: "",
          FechaOriginal: null,
          HoraOriginal: null

        },
        parametros_TiposEstatusDeExpedientes: [],
        Cita: null,
        NumeroFilasPagina: 10,
        listaExpedientesId: [],
        listaEstatusId: [],
        listaCheckBox: [],
        listaEstatusExpSinOpcionReagendar:[1,5,9,12],
        listaBotonAgendamiento: [],
        listaFechaReagendamiento: [],
        listaBloqueReagendamiento: [],
        deshabilitarBotonConfirmar: false,
        estatusGuardados: false,
        textoGenerado: null,
        textoEditable: "",
        indiceExpedienteReagendado: null
      }
    },
    components: {
      C015TiposEstatusDeExpedientes: catalogos.SICCIJ.C015TiposEstatusDeExpedientes,
      C004AgendaBloqueFechas: catalogos.SICCIJ.C004AgendaBloqueFechas,
      C004AgendaBloqueHoras: catalogos.SICCIJ.C004AgendaBloqueHoras
    },
    methods: {
      cargarInfoCita: function () { //Carga la información de BD de una cita.
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.Cita = response.data.Cita
            this.Cita.TramitesCita.forEach(this.cicloTramite);
            this.parametros_AgendaBloqueFechas.FechaOriginal = this.Cita.AgendaBloque.FechaBloque
            this.parametros_AgendaBloqueHoras.FechaOriginal = this.Cita.AgendaBloque.FechaBloque
            this.parametros_AgendaBloqueHoras.HoraOriginal = this.Cita.AgendaBloque.HoraBloque
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      reagendarExpedientes: function () { //Actualiza en BD los estatus de los expedientes.
        var peticion = {
          "esPrueba": false,
          "nuevosBloques": this.listaBloqueReagendamiento,
          "ExpedientesId": this.listaExpedientesId,
          "citaId": this.citaId
        };
        console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.ReagendarExpedientes, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            if (!response.data.reagendamientoExitoso) {
              comun.mensajeDeAlerta(response.data.mensajeBloquesNoDisponibles, null, null)
            } else {
              this.actualizarEstatusExpedientes();
            }
          }
          else {
            console.error(response);
            //comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }, 
      actualizarEstatusExpedientes: function () { //Actualiza en BD los estatus de los expedientes.
        var peticion = {
          "esPrueba": false,
          "ExpedientesId": this.listaExpedientesId,
          "EstatusExpedientesId": this.listaEstatusId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.ActualizarEstatusExpedientes, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.RevisarEstatusExpedientesCita();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      RevisarEstatusExpedientesCita: function () { //Actualiza en BD los estatus de los trámites y de la cita.
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        //comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.RevisarEstatusExpedientesCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.GenerarTextoCorreoAvisoSolicitanteDeCita();
            this.estatusGuardados = true;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          //comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      GenerarTextoCorreoAvisoSolicitanteDeCita: function () { //Obtiene el texto autogenerado para el correo de notificación.
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        //comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GenerarTextoCorreoAvisoSolicitanteDeCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.textoGenerado = response.data.TextoGenerado;
            this.textoEditable = response.data.TextoEditable;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          //comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      EnviarCorreoSolicitante: function () { //Hace la petición de envio de correo electrónico al solicitante.
        var textoCorreo = this.textoGenerado.replace(/<br>/g, "\n");
        var peticion = {
          "esPrueba": false,
          "ContenidoCorreo": textoCorreo + "\n" + this.textoEditable,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.EnviarCorreoSolicitante, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.mensajeCorreoEnviado();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      modalReagendamiento: function (indice) {
        this.indiceExpedienteReagendado = indice;
        $("#modalConfirmacion").modal();
      },
      guardarFechaReagendamiento: function () {
        this.listaFechaReagendamiento[this.indiceExpedienteReagendado] = this.parametros_AgendaBloqueFechas.FechaSeleccionada + " " + this.parametros_AgendaBloqueHoras.Hora.substring(0, 5);
        this.listaBloqueReagendamiento[this.indiceExpedienteReagendado] = this.parametros_AgendaBloqueHoras.BloqueId;
        this.$forceUpdate();
      },
      cancelarReagendamiento: function (indice) {
        this.listaFechaReagendamiento[indice] = null;
        this.listaBloqueReagendamiento[indice] = null;
        this.$forceUpdate();
      },
      validarEstatusExpedientes: function () { //Verifica si el valore de estatus para un expediente de la cita es válido y habilita o deshabilita el botón para continuar.
        var x = this.listaEstatusId.findIndex(function (estatusId) {
          if (estatusId == -1) { return true; }
          else { return false; }
        });
        this.deshabilitarBotonConfirmar = x != -1;
      },
      cambioTipoEstatusDeExpediente(datos) { //Administra los cambios en el componente de estatus de expedientes.
        //console.log(datos.target.id);
        this.parametros_TiposEstatusDeExpedientes[datos.target.id].tipoEstatusDeExpedienteId_ = parseInt(datos.target.value);
        this.listaEstatusId[datos.target.id] = parseInt(datos.target.value);
        this.validarEstatusExpedientes();
        this.validarBotonReagendamiento(datos.target.id);
      },
      cambioAgendaBloqueFecha(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_AgendaBloqueFechas.AgendaBloqueFecha = datos[0].target.value;
        this.parametros_AgendaBloqueFechas.FechaSeleccionada = datos[0].target.options[datos[0].target.selectedIndex].text;
        this.parametros_AgendaBloqueHoras.Fecha = datos[0].target.value;
        this.parametros_AgendaBloqueHoras.BloqueId = -1
      },
      cambioAgendaBloqueHora(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_AgendaBloqueHoras.BloqueId = parseInt(datos[0].target.value);
        this.parametros_AgendaBloqueHoras.Hora = datos[0].target.options[datos[0].target.selectedIndex].text;
      },
      validarCheckBox: function (valor, indice) { //Se ejecuta al cambiar del valor de status de un expediente y verifica su valor
        //console.log(valor, indice);
        if (valor) {
          this.listaEstatusId[indice] = 1;
        } else {
          this.listaEstatusId[indice] = -1;
        }
        this.validarEstatusExpedientes();
        this.validarBotonReagendamiento(indice);
      },
      validarBotonReagendamiento: function (indice) {
        console.log(this.listaEstatusId[indice])
        this.listaBotonAgendamiento[indice] = !this.listaCheckBox[indice] && this.listaEstatusId[indice] > 0 && !this.listaEstatusExpSinOpcionReagendar.includes(this.listaEstatusId[indice]);
        if (!this.listaBotonAgendamiento[indice]) {
          this.listaBloqueReagendamiento[indice] = null;
          this.listaFechaReagendamiento[indice] = null;
        }
        console.log(this.listaBotonAgendamiento[indice])
        this.$forceUpdate();

      },
      confirmacionCancelar: function () { //Muestra un mensaje qué pide confirmar al usuario que desea cancelar el proceso de asignación de estatus a los expedientes.
        var funcion = this.volverConsultaCitas

        $('.bootbox.modal').modal('hide');
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Seguro que desea regresar a las citas pendientes?<br> Perdera los cambios en esta cita.",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No"
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí"
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              return funcion();
            }
          }
        });
      },
      mensajeCorreoEnviado: function () { //Notifica que el correo de notificación fué enviado correctamente.
        var funcion = this.volverConsultaCitas

        $('.bootbox.modal').modal('hide');
        bootbox.alert({
          title: "Mensaje del sistema",
          message: "Correo enviado satisfactoriamente.",
          buttons: {
            ok: {
              label: 'Aceptar'
            }
          },
          callback: function () {
            return funcion();
          }
        });
      },
      volverConsultaCitas: function () { //Redirige a la pantalla de 'CitasSolicitadas'.
        //alert('volver')
        this.$router.push({
          name: 'CitasSolicitadas'
        })
        return;
      },
      VolverExpedientes: function () {
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.RegresarExpedientes, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.estatusGuardados = false;
            this.$forceUpdate();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      cicloTramite: function (Tramite) {
        Tramite.Expedientes.forEach(this.cicloExpediente);
      },
      cicloExpediente: function (Expediente) {
        //console.log(Expediente.ExpedienteId);
        Expediente.Indice = this.listaExpedientesId.length
        this.listaExpedientesId.push(Expediente.ExpedienteId);
        this.listaEstatusId.push(1);
        this.listaCheckBox.push(true);
        this.listaBotonAgendamiento.push(false);
        this.listaFechaReagendamiento.push(null);
        this.listaBloqueReagendamiento.push(null);
        this.parametros_TiposEstatusDeExpedientes.push(
          {
            ValorDefinido: -1,
            TipoEstatusDeExpedienteId: null,
            ConInactivas: false
          }
        );
      }, prueba: function () {

      }
    }, mounted: function mounted() {
      this.cargarInfoCita();
    }, computed: {

    }

  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  span {
    margin-bottom: 5px;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/CitasSolicitadas/DetalleDeCita.vue